module.exports = __webpack_public_path__ + "media/images/gray-waves-da70b1463c235e28eee026cd47f019e9.png";